import styled from 'styled-components';

export const LoadingPageWrapper = styled.section`
  display: flex;
  justify-content: center;
  padding-top: 10rem;
  min-height: 27.25rem;
`;
